<template>
  <div class="XStack flex">
    <div
      class="flex w-full"
      :class="[
        base === 'col' ? 'flex-col' : 'flex-row',

        xs === 'col' && 'xs:flex-col',
        sm === 'col' && 'sm:flex-col',
        md === 'col' && 'md:flex-col',
        lg === 'col' && 'lg:flex-col',
        xl === 'col' && 'xl:flex-col',

        xs === 'row' && 'xs:flex-row',
        sm === 'row' && 'sm:flex-row',
        md === 'row' && 'md:flex-row',
        lg === 'row' && 'lg:flex-row',
        xl === 'row' && 'xl:flex-row',
        {
          'xs:h-full': xs === 'row',
          'sm:h-full': sm === 'row',
          'md:h-full': md === 'row',
          'lg:h-full': lg === 'row',
          'xl:h-full': xl === 'row',
        },
        ...classes,
        margin && '-w-m',
      ]"
      :style="createStyle({ '--child-margin': margin })"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import { useMargin, type StackingProps, useStackingClasses } from './utils'
import { createStyle } from '/@/utils/misc'

type Direction = 'col' | 'row'

export default defineComponent({
  props: {
    spacing: String,
    base: {
      type: String as PropType<Direction>,
      default: 'row',
    },
    xs: {
      type: String as PropType<Direction>,
    },
    sm: {
      type: String as PropType<Direction>,
    },
    md: {
      type: String as PropType<Direction>,
    },
    lg: {
      type: String as PropType<Direction>,
    },
    xl: {
      type: String as PropType<Direction>,
    },
    fill: Boolean,
  },
  setup(props) {
    const margin = useMargin(props as StackingProps)
    const classes = useStackingClasses(props as StackingProps)

    return {
      createStyle,
      margin,
      classes,
    }
  },
})
</script>

<style lang="scss">
.XStack {
  width: inherit;
  height: inherit;

  &.-fill {
    flex: 1;
  }

  > div {
    flex: inherit;
    --child-margin: 0;

    &.-w-m {
      > * + * {
        margin-top: var(--child-margin);
      }
    }
  }
}
</style>
